import { AutogenLayoutContact } from "./autogen/AutogenLayoutContact";

export class Contact extends AutogenLayoutContact {

}
